import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import moment from 'moment';

let lastUpdateDragTime = 0;

const fieldTypeWidths = {
	'text': 300,
	'number': 100,
	'boolean': 70,
	'date': 200,
	'time': 100,
	'currency': 150,
	's3file': 100
};
const isTextTruncated = (element, dragMetadata) => {
	if (element) {

		const spanElement = element.querySelector('span');
		const sortElement = element.querySelector('i');
		let overflowWidth = 0;
		if (sortElement) {
			//considers the width of the sorting icon if present
			overflowWidth = sortElement.clientWidth + spanElement.offsetWidth;
		} else {
			overflowWidth = spanElement.offsetWidth;
		}
		let elementWidth = dragMetadata ? dragMetadata.width : element.clientWidth;
		return elementWidth <= overflowWidth;
	} else {
		return false;
	}
}
const columnRefs = {};
class ViewsTable extends Component {
	constructor(props) {
		super(props);
		this.sidebarScroll = React.createRef();
		this.contentScroll = React.createRef();
		this._preventEvent = false;
		this.contentLastScrollTop = 0;
		this.contentLastScrollLeft = 0;
		props.columns.forEach((c, i) => {
			columnRefs[c.key] = React.createRef();
		});
		this.state = {
			hoverIndex: null,
			lastCheckedIndex: null,
			hoverColumnActive: null,
			columnMetadata: [],
			interval: null,
			loading: true
		};
	}

	componentDidMount() {
		const { columns, defaultSort, sortDirection } = this.props;
		this.dragImg = new Image(0, 0);
		this.dragImg.src =
			'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

		if (defaultSort) {
			if (sortDirection && sortDirection == 'desc') {
				this.props.sortData(columns.find((c) => c.key == defaultSort), false, true);

			} else {
				this.props.sortData(columns.find((c) => c.key == defaultSort), true, false);
			}
		}

		this.setState({ loading: false });
	}

	onSidebarScroll = (e) => {
		if (this._preventEvent) {
			this._preventEvent = false;
			return;
		}

		this._preventEvent = true;
		this.contentScroll.current.scrollTop = e.target.scrollTop;
	};

	onContentScroll = (e) => {
		if (this._preventEvent) {
			this._preventEvent = false;
			return;
		}

		if (e.target.scrollTop !== this.contentLastScrollTop) {
			this._preventEvent = true;
			if (this.sidebarScroll && this.sidebarScroll.current) {
				this.sidebarScroll.current.scrollTop = e.target.scrollTop;
			}
			this.contentLastScrollTop = e.target.scrollTop;
		}
	};

	RowItem(meta, index) {
		const { columns, toggledColumns, checked, checkRow, onClick, readOnly, columnWidths, activeRow, disableCheck, mainColumnActive, rowSettings, rowDetails, detailsTitle } = this.props;
		const { hoverIndex, columnMetadata } = this.state;
		let isStrikeThrough = false;
		meta.isStrikeThrough && meta.isStrikeThrough == true ? isStrikeThrough = true : isStrikeThrough = false;

		return (
			<div
				style={{ margin: 'auto 0', position: isStrikeThrough ? 'relative' : '' }}
				key={`row-${meta._id}-${index}`}
				className={`tableColumnRow ${hoverIndex == index ? 'hover' : ''} ${!activeRow ? '' : (activeRow == meta._id || checked[meta._id])
					? 'checked'
					: ''} ${onClick ? 'c-pointer' : ''}`}
				onClick={() => {
					onClick && onClick(meta._id);
				}}
			>
				{isStrikeThrough && <div className='strikeThrough'
				></div>}
				{columns.map((c, i) => {
					let value = '';
					if (typeof meta[c.key] != 'undefined' && meta[c.key] != null) {
						if (typeof meta[c.key] == 'boolean') {
							value = meta[c.key] ? 'Yes' : 'No';
						} else if (c.type == 'icon') {
							value = <i className={`${meta[c.key]}`} />;
						} else if (c.type == 'date') {
							const dateStamp = meta[c.key];
							value = dateStamp !== '' ? moment(meta[c.key]).format('MM/DD/YYYY') : '';
						} else if (c.type == 'timestamp') {
							const timeStamp = meta[c.key];
							value = timeStamp && timeStamp !== '' ? moment(timeStamp).format('MM/DD/YYYY h:mm a') : '';
						} else if (c.type == 'time') {
							const today = moment().format('YYYY-MM-DD');
							const valueTime = meta[c.key];
							value =
								valueTime && valueTime !== '' ? moment(`${today} ${valueTime}`).format('h:mm a') : '';
						} else if (c.type == 'link') {
							value = (
								<a className="link" href={meta[c.key]} target="_blank">
									{meta[c.key]}
								</a>
							);
						} else if (c.type == 'bool') {
							value = meta[c.key] ? 'Yes' : 'No';
						} else if (c.type == 'currency') {
							const currency = parseFloat(meta[c.key]);

							value = !isNaN(currency) ? `$${currency.toFixed(2)}` : `$${0}`;
						} else if (c.type == 'status') {
							value = meta[c.key].charAt(0).toUpperCase() + meta[c.key].slice(1);
						} else {
							value = meta[c.key];
						}
					}
					return (
						toggledColumns[c.key] && (
							<div
								className="tableColumnRowCell "
								key={`cell-${c.key}-${index}-${i}`}
								style={{
									width: columnMetadata[c.key] ? columnMetadata[c.key].width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
									minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
									maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180
								}}
							>

								{!readOnly &&
									!disableCheck &&
									i == 0 && (
										<div
											className={`checkBox mr-10 ${checked[meta._id] ? 'checked' : ''}`}
											onClick={(e) => {
												e.stopPropagation();
												if (e.shiftKey) {
													this.shiftCheck(meta._id, index);
												} else {
													this.setState({ lastCheckedIndex: index });
													checkRow(meta._id);
												}
											}}
										>
											<i className="las la-check" />
										</div>
									)}
								<div
									className="text-truncate rowText"
								>
									{value}
								</div>
							</div>
						)
					);
				})}
				{rowSettings && rowSettings.length > 0 &&
					<div className='' >
						<div className='detailsContainer' style={{ marginLeft: 'auto', paddingRight: 60 }}>
							<UncontrolledDropdown direction="left" inNavbar >
								<DropdownToggle className="light" style={{ width: 30, height: 30 }}>
									<div className='icon'>
										<i className="las la-ellipsis-v" />
									</div>
								</DropdownToggle>
								<DropdownMenu className="columnDropdown" style={{ minWidth: 230 }}>
									<div className='ph-20'>
										{rowSettings.map((item, index) => {
											let displayCondition = item.displayCondition ? item.displayCondition(meta) : true;
											return (
												<div>
													{displayCondition && <DropdownItem
														className={`moreViewsPopoverItemMenuItem`}
														style={{ textTransform: 'capitalize', padding: '7px 10px' }}
														onClick={() => {
															item.onClick && item.onClick(meta._id);
														}}
													>

														{item.label}
													</DropdownItem>}
												</div>
											)
										})}
									</div>
									{rowDetails &&
										<div>
											<hr />



											<div className='ph-20'>
												<div className="mb-10" style={{ fontWeight: 600 }}>{detailsTitle}</div>
												{Object.keys(rowDetails).map((key, index) => {
													return (
														<div>
															<div className="mb-10">
																<div style={{ fontSize: 12, color: '#999999' }}>{rowDetails[key]}:</div>
																<div>{meta[key]}</div>
															</div>
														</div>
													)
												})}



											</div>
										</div>}
								</DropdownMenu>
							</UncontrolledDropdown>
						</div>
					</div>
				}
			</div>
		);
	}

	mouseHoverStart = (index) => {
		this.setState({ hoverIndex: index });
	};

	mouseHoverEnd = () => {
		this.setState({ hoverIndex: null });
	};

	shiftCheck = (id, index) => {
		const { data, checked, checkRow } = this.props;
		const keys = Object.keys(checked);
		var checkedLength = keys.length;

		if (checkedLength == 0) {
			for (var i = 0; i <= index; i++) {
				//console.log(i);

				checkRow(data[i]._id);
			}
			this.setState({ lastCheckedIndex: index });
		} else {
			let from = this.state.lastCheckedIndex > index ? index : this.state.lastCheckedIndex;
			let to = this.state.lastCheckedIndex < index ? index : this.state.lastCheckedIndex;

			if (keys.includes(id)) {
				for (var i = from; i <= to; i++) {
					checked[data[i]._id] && checkRow(data[i]._id);
				}
			} else {
				for (var i = from; i <= to; i++) {
					!checked[data[i]._id] && checkRow(data[i]._id);
				}
			}
			this.setState({ lastCheckedIndex: index });
		}
	};

	render() {
		const {
			readOnly,
			mainColumnActive,
			toggledColumns,
			checked,
			checkRow,
			checkAllRows,
			data,
			sortData,
			columns,
			disableCheck,
			columnWidths,
			classes,
			rowSettings,
			disableLink,
			noDescription,
			activeRow,
			singleCheck
		} = this.props;
		const { hoverIndex, columnMetadata } = this.state;
		const mainColumn = columns[0] || {};
		const allChecked = data.length === Object.keys(checked).length && Object.keys(checked).length > 0;
		let title = this.props.title

		return mainColumnActive ? (
			<div className={`sectionTable ${classes ? classes : ''}`} style={this.props.style}>
				<div className="tableMainColumn noselect">
					<div className="tableColumnHeader">
						<div className="tableMainColumnCell">
							{!readOnly &&
								!disableCheck && (
									<div
										className={`checkBox mr-10 ${allChecked ? 'checked' : ''} `}
										onClick={(e) => {
											e.stopPropagation();
											checkAllRows(allChecked ? [] : data.map((sd) => sd._id))
										}}
									>
										<i className="las la-check" />
									</div>
								)}
							<div
								className="tableCellData"
								onClick={() => {
									if (mainColumn.sortAsc) {
										sortData(mainColumn, false, true);
									} else {
										sortData(mainColumn, true, false);
									}
								}}
							>
								<div className="tableColumnTitle2">
									{mainColumn.label}

									{mainColumn.sortAsc ? (
										<i className="las la-angle-down" />
									) : mainColumn.sortDesc ? (
										<i className="las la-angle-up" />
									) : (
										''
									)}
								</div>
							</div>
						</div>
					</div>
					<div
						className="tableColumnRows hideScrollbar"
						ref={this.sidebarScroll}
						onScroll={this.onSidebarScroll}
					>
						{data.map((a, i) => {
							return (
								<div
									className={`tableMainColumnRowCell ${hoverIndex == i ? 'hover' : ''} ${activeRow == a._id || checked[a._id]
										? 'checked'
										: ''}`}
									key={a._id}
								/* onMouseEnter={() => this.mouseHoverStart(i)}
								onMouseLeave={() => this.mouseHoverEnd()} */
								>
									{!readOnly && !disableCheck && (
										<div
											className={`checkBox mr-10 ${checked[a._id] ? 'checked' : ''}`}
											onClick={(e) => {
												if (e.shiftKey) {
													this.shiftCheck(a._id, i);
												} else {
													this.setState({ lastCheckedIndex: i });
													checkRow(a._id);
												}
											}}
										>
											<i className="las la-check" />
										</div>
									)}
									{(!disableLink && a.link ? <Link to={a.link} className="tableCellData">
										<div id={`mainColumn${i}`} className="tableRowText">
											{a[mainColumn.key]}
											{a[mainColumn.key].length >= 30 &&
												<UncontrolledTooltip innerClassName="custom-tooltip"/*  delay={{ "show": '1000', "hide": '0' }} */ placement="top" target={`mainColumn${i}`}>
													{a[mainColumn.key]}
												</UncontrolledTooltip>
											}
										</div>
										<i className="las la-angle-right ml-a" />
									</Link> : <div className="tableCellData">
										<div className="tableRowText">{a[mainColumn.key]} </div></div>)}
								</div>
							);
						})}
					</div>
				</div>
				<div className="tableSubColumns neu"


					onMouseEnter={(evt) => {
						//console.log('mouseenter', evt);
					}}
					onMouseLeave={() => {


					}}>
					<div className="tableColumnHeader">
						{columns.map(

							(c, i) => {

								return (
									!(mainColumn.key == c.key) && toggledColumns[c.key] && (
										<div
											className="tableSubColumn"
											style={{
												width: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
												minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
												maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180
											}}
											key={c.key}
											onClick={() => {
												if (c.sortAsc) {
													sortData(c, false, true);
												} else {
													sortData(c, true, false);
												}
											}}
										>
											<div className="tableColumnTitle2 flex-ac">
												<div
													ref={columnRefs[c.key]}
													style={{
														width: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
														minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
														maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap'
													}} id={`header${i}`}><span>{c.label}</span>
													{c.sortAsc ? (
														<i className="las la-angle-down" />
													) : c.sortDesc ? (
														<i className="las la-angle-up" />
													) : (
														''
													)}

												</div>
												{isTextTruncated(columnRefs[c.key]?.current, columnMetadata[c.key] || null) &&
													<UncontrolledTooltip className="toooltip" placement="bottom" target={`header${i}`}>
														{c.label}
													</UncontrolledTooltip>
												}
											</div>

											< div className={'ml-a dragHandle'}
												draggable
												onDrag={async (evt) => {
													//time
													const currentTime = new Date().getTime();
													//console.log(currentTime - lastUpdateDragTime)
													/* if(currentTime - lastUpdateDragTime  > 5) {
														lastUpdateDragTime = currentTime;
													} else {
														let editedColumnMetadata = columnMetadata;
														let previousInitialWidth = columnMetadata[c.key].initialWidth;
														let newWidth = previousInitialWidth + (evt.clientX - columnMetadata[c.key].initialPoint);
														editedColumnMetadata[c.key].initialPoint = evt.clientX;
														editedColumnMetadata[c.key].initialWidth = newWidth;
														editedColumnMetadata[c.key].width = newWidth;
														this.setState({ columnMetadata: editedColumnMetadata });
													} */

													let previousInitialWidth = columnMetadata[c.key].initialWidth;
													let newWidth = previousInitialWidth + (evt.clientX - columnMetadata[c.key].initialPoint);
													//update horizontal margin using style
													if (evt.clientX > 0)
														evt.target.style.marginRight = previousInitialWidth - newWidth + 'px';

													//console.log(evt.target)

												}}
												onDragStart={(evt) => {
													evt.dataTransfer.setDragImage(this.dragImg, 0, 0);

													let editedColumnMetadata = columnMetadata;
													if (editedColumnMetadata[c.key]) {
														editedColumnMetadata[c.key].initialPoint = evt.clientX;
													} else {
														editedColumnMetadata[c.key] = { initialPoint: evt.clientX, initialWidth: 180 };
													}

													//columnMetadata = editedColumnMetadata;
													this.setState({ columnMetadata: editedColumnMetadata });
												}}
												onDragEnd={(evt) => {
													evt.target.style.marginRight = '0px';
													let editedColumnMetadata = columnMetadata;
													let previousInitialWidth = columnMetadata[c.key].initialWidth;
													let newWidth = previousInitialWidth + (evt.clientX - columnMetadata[c.key].initialPoint);
													editedColumnMetadata[c.key].initialPoint = evt.clientX;
													editedColumnMetadata[c.key].initialWidth = newWidth;
													editedColumnMetadata[c.key].width = newWidth;
													//console.log(newWidth)
													//columnMetadata = editedColumnMetadata;
													this.setState({ columnMetadata: editedColumnMetadata });
												}}
											>
												<i className="las la-arrows-alt-h nueHandle"></i>
											</div>
										</div>
									)

								)
							}
						)}

						{rowSettings && rowSettings.length > 0 &&
							<div className="tableSubColumn"
								style={{
									width: 100,
									minWidth: 100,
									maxWidth: 100
								}}
							>
							</div>}
					</div>
					<div className="tableColumnRows w-fc" ref={this.contentScroll} onScroll={this.onContentScroll}>
						{data.map((d, i) => this.RowItem(d, i))}

						{data.length == 0 ?
							<div className='BlankTable'>
								<h2 className='mb-15'> No {title} Yet</h2>

								{!noDescription && <p className='tableLabel'> Add <span className='lower' > {title} </span>{this.props.importAvailable && <span> or import <span className='lower'> {title} </span>  from a spreadsheet </span>} to view and manage.</p>}
							</div>
							: false
						}
					</div>
				</div>
			</div >
		) : (
			<div className={`sectionTable ${classes}`} style={this.props.style}>
				<div className="tableSubColumns fit">
					<div className="tableColumnHeader">
						{columns.map(
							(c, i) =>
								toggledColumns[c.key] && (
									<div
										className="tableSubColumn"
										style={
											{
												width: columnMetadata[c.key] ? columnMetadata[c.key].width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
												minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
												maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : columnWidths && columnWidths[c.key] ? columnWidths[c.key] : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180
											}
										}
										onClick={() => {
											if (c.sortAsc) {
												sortData(c, false, true);
											} else {
												sortData(c, true, false);
											}
										}}
									>
										{!readOnly &&
											!disableCheck && !singleCheck &&
											i == 0 && (
												<div
													className={`checkBox mr-10 ${allChecked ? 'checked' : ''}`}
													onClick={(e) => {
														e.stopPropagation();
														checkAllRows(allChecked ? [] : data.map((sd) => sd._id))
													}}
												>
													<i className="las la-check" />
												</div>
											)}
										{singleCheck && i == 0 && <div className='mr-25'> </div>}
										<div className="tableColumnTitle2 flex-ac">
											<div
												ref={columnRefs[c.key]}
												style={{
													width: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
													minWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
													maxWidth: columnMetadata[c.key] ? columnMetadata[c.key].width : fieldTypeWidths[c.type] ? fieldTypeWidths[c.type] : 180,
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap'
												}} id={`header${i}`}><span>{c.label}</span>
												{c.sortAsc ? (
													<i className="las la-angle-down" />
												) : c.sortDesc ? (
													<i className="las la-angle-up" />
												) : (
													''
												)}

											</div>
											{isTextTruncated(columnRefs[c.key].current, columnMetadata[c.key] || null) &&
												<UncontrolledTooltip className="toooltip" placement="bottom" target={`header${i}`}>
													{c.label}
												</UncontrolledTooltip>
											}
										</div>

									</div>
								)
						)}
					</div>
					<div className="tableColumnRows w-fc" ref={this.contentScroll} onScroll={this.onContentScroll}>
						{data.map((d, i) => this.RowItem(d, i))}
						{data.length == 0 ?
							<div className='BlankTable'>
								<h2 className='mb-15'> No {title} Yet</h2>

								{!noDescription && <p className='tableLabel'> Add <span className='lower' > {title} </span>{this.props.importAvailable && <span> or import <span className='lower'> {title} </span>  from a spreadsheet</span>} to view and manage.</p>}
							</div>
							: false
						}
					</div>
				</div>
			</div >
		);
	}
}

export default ViewsTable;
